import { axiosInstance } from "../../Utils/AxiosInstance";

export const AddStockAdjustmentApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/Store/StockAdjustment/Create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
